"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const react_native_1 = require("react-native");
const Breakpoints_1 = require("../../../helper/Breakpoints");
exports.styles = react_native_1.StyleSheet.create({
    scrollView: {
        paddingStart: 25,
        paddingEnd: 25,
    },
    container: {
        flex: 1,
        height: react_native_1.Platform.OS === 'web' ? '100vh' : '100%',
        marginHorizontal: 'auto',
        marginVertical: 20,
        width: Breakpoints_1.isDesktop ? 1080 : '100%',
    },
    heading3: {
        fontSize: 20,
        fontWeight: 'bold',
        marginVertical: 20,
        color: '#000',
    },
    introText: {
        marginBottom: 20,
    },
    input: {
        marginRight: 0,
    },
    buttonContainer: {
        justifyContent: 'space-between',
        paddingBottom: 50,
        alignItems: 'center',
    },
    button: {
        backgroundColor: '#3db384',
        borderRadius: 24,
        paddingHorizontal: 50,
        paddingVertical: 10,
    },
    buttonText: {
        color: '#fff',
    },
    errorText: {
        position: 'absolute',
        color: '#ff0000',
        bottom: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? -37 : -23,
    },
    errorTextBottom25: {
        bottom: 25,
    },
});
